export default __webpack_public_path__ + "static/media/built-on-ardor-blockchain.2d4e5772.png";